<script lang="ts">
    import json from "../../public/notices/index.json";
    let notices = json as {
        filename: string;
        pretty: string;
        preview: string;
    }[];
</script>

<main>
    {#each notices as notice}
        <a href={notice.filename}>
            <img src={notice.preview} alt={notice.pretty} />
            {notice.pretty}
        </a>
    {/each}
</main>

<style>
    img {
        display: inline-block;
        margin: auto;
        width: 100%;
    }
    a {
        display: inline-block;
        margin: 10px;
        text-align: center;
        width: 170px;
    }
</style>
